<template>
  <ankh-list>
    <template #btn-group>
      <el-button @click.native="handleAdd">{{$t('新增')}}</el-button>
      <el-button @click.native="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <template #search-form>
      <el-form-item :label="$t('名称')">
        <el-input :placeholder="$t('名称')" v-model="searchForm.name" clearable/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{$t('搜索')}}</el-button>
        <el-button @click="$refs.list.reset()">{{$t('重置')}}</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">
      <table-list
          :height="height"
          ref="list"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>

        <el-table-column prop="num" :label="$t('编号')" fixed />
        <el-table-column prop="name" :label="$t('套餐名称')" fixed />
        <el-table-column prop="price" :label="$t('价格')"/>
        <el-table-column :label="$t('增加会员积分')" prop="addVipIntegral"/>
        <el-table-column :label="$t('增加使用者积分')" prop="addUserIntegral"/>
        <el-table-column :label="$t('增加发布者积分')" prop="addReleaseIntegral"/>
        <el-table-column fixed="right" :label="$t('操作')" min-width="30">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="primary" :underline="false" @click="handleEditRow(row)">{{$t('编辑')}}</el-link>
              <el-link type="danger" :underline="false" @click="handleDelete(row)">{{$t('删除')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>

    <template slot="other">
      <el-dialog :visible.sync="showDialog" :close-on-click-modal="false" @close="handleCloseDialog">
        <template #title>
          <h4>{{isEdit ? $t('编辑') : $t('新增')}}{{$t('会员套餐')}}</h4>
        </template>

        <el-form label-width="auto" label-position="left" ref="form" :model="formData" :rules="rules">
          <el-form-item :label="$t('套餐名称')" required>
            <div class="flex-center" style="column-gap: 10px">
              <el-select v-model="formData.number" :placeholder="$t('请选择')">
                <el-option v-for="item in dayNums" :value="item" :label="item" :key="item"/>
              </el-select>
              <span>-</span>
              <el-select v-model="formData.unit" :placeholder="$t('请选择')" @change="handleChangeDayUnit">
                <el-option v-for="(item, index) in Object.keys(TIME_DAY)" :key="index" :value="$t(item)" :label="$t(item)"/>
              </el-select>
            </div>
          </el-form-item>

          <el-form-item :label="$t('套餐价格')" prop="price">
            <el-input :placeholder="$t('套餐价格')" v-model.number="formData.price"/>
          </el-form-item>
          <el-form-item :label="$t('增加会员积分')" prop="addVipIntegral">
            <el-input :placeholder="$t('增加会员积分')" v-model.number="formData.addVipIntegral"/>
          </el-form-item>
          <el-form-item :label="$t('增加使用者积分')" prop="addUserIntegral">
            <el-input :placeholder="$t('增加使用者积分')" v-model.number="formData.addUserIntegral"/>
          </el-form-item>
          <el-form-item :label="$t('增加发布者积分')" prop="addReleaseIntegral">
            <el-input :placeholder="$t('增加发布者积分')" v-model.number="formData.addReleaseIntegral"/>
          </el-form-item>
        </el-form>

        <template #footer>
          <el-button type="primary" @click="handleSaveSubmit">{{$t('保存')}}</el-button>
          <el-button @click="handleResetForm">{{$t('重置')}}</el-button>
        </template>
      </el-dialog>
    </template>
  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import {resetEmpty} from "@/utils/common";
import AnkhList from "@/components/list/AnkhList.vue";

// 套餐时间
const TIME_DAY = {
  "天": 31,
  "月": 12,
}

export default {
  name: "SimilarRecipeList",
  components: {AnkhList, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      showDialog: false,
      TIME_DAY,

      formData: {
        number: 1,
        unit: this.$t('天'),
        price: "",
        addVipIntegral: null,
        addUserIntegral: null,
        addReleaseIntegral: null,
      },

      rules: {
        price: {required: true, message: this.$t('请输入价格'), trigger: "blur"},
        addVipIntegral: {required: true, message: this.$t('请输入增加会员积分'), trigger: "blur"},
        addUserIntegral: {required: true, message: this.$t('请输入增加使用者积分'), trigger: "blur"},
        addReleaseIntegral: {required: true, message: this.$t('请输入增加发布者积分'), trigger: "blur"},
      },
      currentRow: {},
      isEdit: false,
    }
  },
  methods: {
    // 保存提交表单
    handleSaveSubmit() {
      try {
        this.$refs.form.validate(async valid => {
          if(!valid) return;
          console.log('this.formData', this.formData)
          const params = {...this.formData};
          params["name"] = params.number + params.unit;
          // 编辑
          if(this.isEdit) {
            params["code"] = this.currentRow.code;
            params["num"] = this.currentRow.num;
          }
          const api = this.$api.vipSetmeal[this.isEdit ? "update" : "add"];
          await request(api, params);
          this.$message.success(this.$t('操作成功'));
          this.$refs.list.handleRequest();
          this.showDialog = false;
        })
      } catch (e) {
        console.log(e);
      }
    },

    handleCloseDialog() {
      this.currentRow = {};
      this.handleResetForm();
    },

    // 重置表单
    handleResetForm() {
      this.$refs.form.resetFields();
      resetEmpty(this.formData);
      this.formData.dayUnit = this.$t('天');
      this.formData.dayNum = 1;
    },

    handleAdd() {
      this.isEdit = false;
      this.showDialog = true;
    },

    // 编辑
    handleEditRow(row) {
      for (const key in this.formData) {
        this.formData[key] = row[key];
      }
      // 取出时间和单位
      const num = row.name.match(/\d+/)[0];
      console.log('row', row);
      console.log('num', num);
      const unit = row.name.split(num)[1];
      this.formData.number = num;
      this.formData.unit = unit;
      this.currentRow = row;
      this.isEdit = true;
      this.showDialog = true;
    },

    // 切换日期单位
    handleChangeDayUnit() {
      this.formData.dayNum = null;
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.vipSetmeal.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest();
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      try {
        let codes = this.selection.map(item => item.code);
        if (!codes.length) {
          this.$message.error(this.$t('请选择要删除的数据'));
          return;
        }
        await requestByTip(
            this.$api.vipSetmeal.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t('您现在正在进行批量删除操作, 是否继续?')}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();

      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.vipSetmeal.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    }
  },
  computed: {
    dayNums() {
      return TIME_DAY[this.formData.unit];
    },
  }
}
</script>

<style scoped>

/deep/ .el-dialog {
  width: 550px;
  border-radius: 10px;
}
</style>
